module.exports = __webpack_public_path__ + "img/BABO-03.ad7fd129.png";